// React-based Commands for GrapesJS
import type { GrapesJSEditor } from '../types/grapesjs';

const API_BASE = import.meta.env.VITE_API_URL || 'http://localhost:4000';

export function registerCommands(editor: GrapesJSEditor): void {
  const Commands = editor.Commands

  // Clear canvas command
  Commands.add('clear-canvas', {
    run: (editor) => {
      if (confirm('Are you sure you want to clear the canvas?')) {
        editor.DomComponents.clear()
        editor.CssComposer.clear()
        editor.UndoManager.clear()
        showNotification('Canvas cleared successfully!', 'success')
      }
    }
  })

  // Preview command
  Commands.add('preview-template', {
    run: (editor) => {
      const html = editor.getHtml()
      const css = editor.getCss()
      
      const previewWindow = window.open('', '_blank')
      previewWindow.document.write(`
        <html>
          <head>
            <title>Template Preview</title>
            <style>${css}</style>
          </head>
          <body>${html}</body>
        </html>
      `)
      previewWindow.document.close()
    }
  })

  // open-template-manager removed — template management handled by React TemplateLibrary component


  // Page Manager Command
  Commands.add('open-page-manager', {
    run: (editor) => {
      console.log('📄 Opening page manager...')
      // This will be handled by the React component
      // The command is available for programmatic access
      showNotification('Page manager opened!', 'info')
    }
  })

  // Domain Manager Command
  Commands.add('open-domains', {
    run: (editor) => {
      console.log('🌐 Opening domain manager...')
      
      // Dispatch a custom event to open the domain manager
      const event = new CustomEvent('openDomainManager', {
        detail: { editor }
      })
      window.dispatchEvent(event)
    }
  })

  // Export code command
  Commands.add('export-code', {
    run: (editor) => {
      console.log('💾 Exporting code...')
      const html = editor.getHtml()
      const css = editor.getCss()
      const js = editor.getJs()

      const blob = new Blob([html, css, js], { type: 'text/plain' })
      const url = URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = 'grapesjs-project.zip'
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      URL.revokeObjectURL(url)
      showNotification('Code exported successfully!', 'success')
    }
  })

  // Helper function for notifications
  function showNotification(message, type = 'info') {
    const notification = document.createElement('div')
    notification.className = `notification notification-${type}`
    notification.textContent = message
    
    notification.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      padding: 12px 20px;
      border-radius: 8px;
      color: white;
      font-weight: 500;
      z-index: 10001;
      animation: slideInRight 0.3s ease-out;
      ${type === 'success' ? 'background: #10b981;' : ''}
      ${type === 'error' ? 'background: #ef4444;' : ''}
      ${type === 'info' ? 'background: #3b82f6;' : ''}
    `
    
    document.body.appendChild(notification)
    
    setTimeout(() => {
      notification.style.animation = 'slideOutRight 0.3s ease-out'
      setTimeout(() => {
        if (notification.parentNode) {
          document.body.removeChild(notification)
        }
      }, 300)
    }, 3000)
  }

  // Add notification animations
  const notificationStyle = document.createElement('style')
  notificationStyle.textContent = `
    @keyframes slideInRight {
      from { transform: translateX(100%); opacity: 0; }
      to { transform: translateX(0); opacity: 1; }
    }
    @keyframes slideOutRight {
      from { transform: translateX(0); opacity: 1; }
      to { transform: translateX(100%); opacity: 0; }
    }
  `
  document.head.appendChild(notificationStyle)

  // Helper function to get default templates
  function getDefaultTemplate(templateId) {
    // No default templates anymore
    return null
  }
} 